import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Pinterest = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12c0 4.26 2.66 7.89 6.4 9.35-.09-.82-.17-2.07.04-2.96.18-.8 1.17-4.97 1.17-4.97s-.3-.6-.3-1.48c0-1.39.81-2.43 1.81-2.43.85 0 1.27.64 1.27 1.41 0 .86-.55 2.14-.83 3.33-.24.99.5 1.8 1.48 1.8 1.77 0 3.14-1.87 3.14-4.57 0-2.39-1.72-4.06-4.17-4.06-2.84 0-4.51 2.13-4.51 4.33 0 .86.33 1.78.74 2.28.08.1.09.19.07.29-.08.31-.24 1.02-.28 1.16-.05.21-.16.25-.37.15-1.32-.61-2.14-2.54-2.14-4.09 0-3.15 2.29-6.04 6.6-6.04 3.47 0 6.16 2.47 6.16 5.77 0 3.44-2.17 6.21-5.18 6.21-1.01 0-1.96-.53-2.29-1.15 0 0-.5 1.91-.62 2.38-.22.87-.83 1.96-1.24 2.62.93.29 1.92.44 2.95.44 5.52 0 10-4.48 10-10S17.52 2 12 2" />
    </Icon>
  );
});

Pinterest.displayName = "Pinterest";
